import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Who_We_Are.css";
import Common_Title from "../../common_component/common_title/Common_Title";

const WhoWeAreSection = () => {
  return (
    <section className="who-we-are">
      <Container>
        <Row className="">
          <Col
            lg={7}
            sm={12}
            md={6}
            className="left-content order-2 order-md-1"
          >
            <div className="title_who_we_are">
              <Common_Title title="Who We Are" />
            </div>

            <p className="description">
              We are a passionate travel company dedicated to creating smooth,
              memorable, and worry-free travel experiences. From dream vacations
              to perfectly planned tours, we help travelers explore the world
              with confidence and comfort.
            </p>

            <h4 className="growth-title">Numbers That Speak</h4>

            <div className="growth-box container">
              <div>
                <h5>12+</h5>
                <p>Learners</p>
              </div>
              <div>
                <h5>60+</h5>
                <p>Dream Destination</p>
              </div>
              <div>
                <h5>50+</h5>
                <p>Destinations</p>
              </div>
              <div>
                <h5>8+</h5>
                <p>Years Experience</p>
              </div>
            </div>
          </Col>

          
            <Col
              lg={5}
              sm={12}
              md={6}
              className="right-image order-1 order-md-2"
            >
              <img
                src="/assets/images/about-us/who-we-are/who_we_are.png"
                alt="Students"
                className="img-fluid"
              />
            </Col>
         
        </Row>
      </Container>
    </section>
  );
};

export default WhoWeAreSection;
